var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentimentanalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.3335C11.6827 1.3335 14.6673 4.31816 14.6673 8.00016C14.6673 11.6822 11.6827 14.6668 8.00065 14.6668C4.31865 14.6668 1.33398 11.6822 1.33398 8.00016C1.33398 4.31816 4.31865 1.3335 8.00065 1.3335ZM11.0647 4.93616C10.9287 4.7995 10.714 4.78083 10.556 4.8915C8.62932 6.2435 7.54265 7.04483 7.29332 7.29283C6.90332 7.6835 6.90332 8.31683 7.29332 8.7075C7.68398 9.0975 8.31732 9.0975 8.70798 8.7075C8.85398 8.56083 9.65332 7.4735 11.1067 5.44283C11.2187 5.28683 11.2007 5.07216 11.0647 4.93616ZM11.6673 7.3335C11.2993 7.3335 11.0007 7.63216 11.0007 8.00016C11.0007 8.36816 11.2993 8.66683 11.6673 8.66683C12.0353 8.66683 12.334 8.36816 12.334 8.00016C12.334 7.63216 12.0353 7.3335 11.6673 7.3335ZM4.33398 7.3335C3.96598 7.3335 3.66732 7.63216 3.66732 8.00016C3.66732 8.36816 3.96598 8.66683 4.33398 8.66683C4.70198 8.66683 5.00065 8.36816 5.00065 8.00016C5.00065 7.63216 4.70198 7.3335 4.33398 7.3335ZM5.87932 4.93616C5.61932 4.67616 5.19665 4.67616 4.93665 4.93616C4.67665 5.19616 4.67665 5.61816 4.93665 5.87883C5.19665 6.13883 5.61865 6.13883 5.87932 5.87883C6.13932 5.61883 6.13932 5.19616 5.87932 4.93616ZM8.00065 3.66683C7.63265 3.66683 7.33398 3.9655 7.33398 4.3335C7.33398 4.7015 7.63265 5.00016 8.00065 5.00016C8.36865 5.00016 8.66732 4.7015 8.66732 4.3335C8.66732 3.9655 8.36865 3.66683 8.00065 3.66683Z",
    fill: "#6756BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentanalysis);
export default __webpack_public_path__ + "static/media/sentimentanalysis.a778d36540536fc71a5c0823fd53da58.svg";
export { ForwardRef as ReactComponent };